import React from 'react';
import PropTypes from 'prop-types';

import decorate from '_core/utils/decorate';
import { debounce } from '_core/utils/async';
import ResizeObservable from '_core/components/ResizeObservable';


export default decorate(class extends React.PureComponent {
  
  static displayName = 'Sticky';
  
  static decorateWith = {
  };
  
  static propTypes = {
    children: PropTypes.node
  };
  
  static defaultProps = {
    position: 'centered'
  };
  
  
  constructor(props) {
    super(props);
    
    this.state = { left: 0, top: 0, width: 0, height: 0 };
    
    this.rootRef = React.createRef();
    this.containerRef = React.createRef();
  }
  
  
  onScroll = debounce(() => {
    const rootRect = this.rootRef.current?.getBoundingClientRect();
    const containerRect = this.containerRef.current?.getBoundingClientRect();
    
    if (!rootRect || !containerRect)
      return;
    
    const rootLeft = rootRect.left;
    const rootTop = rootRect.top;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const containerWidth = containerRect.width;
    const containerHeight = containerRect.height;
    
    
    this.setState((state) => {
      const newState = {
        ...state,
        
        rootLeft,
        rootTop,
        containerWidth,
        containerHeight
      };
      
      if (this.props.position === 'bordered') {
        const { borderedPadding } = this.props;
        
        
        // horizontal
        
        const leftOffset = -rootLeft;
        const rightOffset = windowWidth - rootLeft - containerWidth;
        
        newState.left = Math.min(Math.max(newState.left, rightOffset), leftOffset);
        
        
        // vertical
        
        const topOffset = -rootTop + (borderedPadding?.top || 0);
        const bottomOffset = windowHeight - rootTop - containerHeight - (borderedPadding?.bottom || 0);
        
        newState.top = Math.min(Math.max(newState.top, bottomOffset), topOffset);
      } else {
        newState.left = (windowWidth - containerWidth) * 0.5 - rootLeft;
        newState.top = (windowHeight - containerHeight) * 0.5 - rootTop;
      }
      
      newState.left = Math.min(Math.max(newState.left, 0), state.width - containerWidth);
      newState.top = Math.min(Math.max(newState.top, 0), state.height - containerHeight);
      
      return newState;
    });
  }, 100);
  
  
  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, true);
    window.addEventListener('resize', this.onScroll, true);
    
    setTimeout(this.onScroll, 100);
  }
  
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
  }
  
  render() {
    const {
      rootClassName,
      containerClassName,
      style,
      children,
      
      ...props
    } = this.props;
    
    const containerStyle = {
      ...style,
      
      position: 'absolute',
      left: this.state.left,
      top: this.state.top
    };
    
    delete props.position;
    delete props.borderedPadding;
    
    return (
      <ResizeObservable
        ref={this.rootRef}
        className={rootClassName}
        containerClassName={containerClassName}
        overflow
        alwaysVisible
        style={{ minHeight: this.state.containerHeight }}
        onChange={({ width, height }) => this.setState((state) => ({ width, height }))}
      >
        <div
          ref={this.containerRef}
          
          {...props}
          
          style={containerStyle}
        >
          {children}
        </div>
      </ResizeObservable>
    );
  }
  
});
